import React from "react";
import Filters from "../../components/filters/Filters";
import LoadSettlementsTable from "../../components/settlements/LoadSettlementsTable";

const Settlements = () => {
  return (
    <section className="flex flex-col space-y-10 py-10">
      <main>
        <Filters />
      </main>
      <section>
        <LoadSettlementsTable />
      </section>
    </section>
  );
};

export default Settlements;
